export default __webpack_public_path__ + "static/media/TRX per CD3D - Icon.36a3bda9.svg";